import React from 'react';
import {Table, Card, Button, Select, Typography, DatePicker, Tag, Modal, Space, Divider, Input} from "antd";
import {customsReportSplits, customsReportList, visualize} from '../api/api'
import moment from "moment";

export const CustomsSelect = ({value,onChange})=>{

    const [customs, setCustoms] = React.useState([])

    const load = async ()=>{
        const {data:{rows = []}} = await visualize('customs')
        setCustoms(rows.map(({id, name})=>({id,name})))
    }

    React.useEffect(()=>{
        load();
    },[])

    return <React.Fragment>
        <Select showSearch optionFilterProp={'children'} placeholder="Select a Customs" style={{width: 400}} key={customs} onChange={onChange} value={value}>
            {
                customs.map(({id,name})=><Select.Option key={id} value={id}>{name}</Select.Option>)
            }
        </Select>
    </React.Fragment>
}


export const CustomsReportView = (props)=>{

    const [customs,setCustoms] = React.useState()
    const [source, setSource] = React.useState([]);
    
    const load = async ()=>{
        if(customs) {
            const {data:{rows=[]}} = await customsReportList({id:customs})
            setSource(rows)
        }else
            setSource([])
    }

    React.useEffect(()=>{
        load();
    },[customs])

    return <React.Fragment>
        <Card
            title={<CustomsSelect value={customs} onChange={e=>setCustoms(e)}/>}
        >
            <Table
                dataSource={source}
                pagination={false}
                size={`small`}
            >

                <Table.Column dataIndex={'id'} title={'Handled Order Report'} render={(value, row, index) => {

                    const { effective_month, customs_id } = row;
                    return <Space key={index}>
                        <Button disabled={false} onClick={async () => {
                            await customsReportSplits(customs_id, effective_month)
                        }}>Download</Button>
                    </Space>;
                }} />
                 <Table.Column dataIndex={'duration'} title={'Duration'} render={(value,row,index)=>{
                    const data = value.split(",").map(o=>{
                        return o.match(/\d{4}-\d{2}-\d{2}/g) || "STARTED"
                    }).join(" - ")
                    return <Typography.Text>{data}</Typography.Text>
                }}/>                
             </Table>
        </Card>

    </React.Fragment>
}